import React from 'react'

import { actionsColumn, conditionNameColumn, mainProviderColumn, providersColumn, sitesColumn } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { minMaxComparisonColumn } from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Table/columns"


export default function MinMaxPriceTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		title="Alerts: Min & Max Price"
		data={data}
		isLoading={isLoading}
		onDeleteAlert={onDeleteAlert}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			...sitesColumn(),
			mainProviderColumn(),
			minMaxComparisonColumn(),
			providersColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)
		]}
		legend={[
			{ icon: "percent", value: '%', label: "Percentage" },
			{ icon: "money-bills", value: '$', label: "Currency", iconProps: { color: "success.dark" } },
			{ icon: "gem", value: 'Most expensive', label: "Most Expensive", iconProps: { color: "colors.purple" } },
			{ icon: "coins", value: 'Cheapest', label: "Cheapest", iconProps: { color: "warning.main" } },
			{ icon: "arrow-up", value: 'Higher than', label: "Higher Than", iconProps: { color: "success.main" } },
			{ icon: "arrow-down", value: 'Lower than', label: "Lower Than", iconProps: { color: "error.main" } },
		]}
	/>
}